export const COMMIT_DIFF_LIST_SIZE = 30;
export const DOCS_CONNECT_JIRA = 'https://confluence.atlassian.com/x/XpCHM';
